<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ page_title }}</strong>
          </CCardHeader>
          <CCardBody>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles

var items = [];


export default {
  name: 'Login',
  components: {},
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
page_title:this.$route.params.page_title,
      validate_errors: [],
      name: '',
      description: '',
      selected_branch: '',
      selected_bank: '',
      bank_no: '',
      sheba_no: '',
      branch_items: [],
      bank_items: [],

      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'bankAccTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {key: 'bankName', label: this.$t('tables.bank'), _style: 'width:10%'},
        {key: 'bankAccCode', label: this.$t('tables.bankAccCode'), _style: 'width:10%'},
        {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'shabaNo', label: this.$t('tables.shabaNo'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      status_form: 0,

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_bank();
    this.get_branches();
    this.get_lists();
    bus.$on('delete_bank_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.selected_branch != 0 && this.selected_bank != 0
          && this.bank_no != '' && this.sheba_no != '' && this.name != '') {
        return true;
      }


      if (this.selected_branch == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBranch'));
      }
      if (this.selected_bank == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBank'));
      }
      if (this.bank_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertBankNo'));
      }
      if (this.sheba_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSheba'));
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertBankName'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      this.name = item.bankAccTitle;
      this.description = item.summary;
      this.selected_branch = item.branchId;
      this.selected_bank = item.bankId;
      this.bank_no = item.bankAccCode;
      this.sheba_no = item.shabaNo;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [];
          self.bank_items = self.sort_array(
                  self.bank_items, content_data.data,
                  'id','bankTitle');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.bankTitle, value: val.id}
          //
          //   self.bank_items.push(obj);
          // });
          self.selected_bank = self.bank_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
                  self.branch_items, content_data.data,
                  'branchId','branchTitle');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.branchTitle, value: val.branchId}
          //   self.branch_items.push(obj);
          // });
          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddBankAccount";
      } else {
        url = "EditBankAccount";
        formData.append('Id', this.status_form)

      }

      formData.append('BankId', this.selected_bank);
      formData.append('BankAccTitle', this.name);
      formData.append('BankAccCode', this.bank_no);
      formData.append('BranchId', this.selected_branch);
      formData.append('ShabaNo', this.sheba_no);
      formData.append('Summary', this.description);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.status_form = 0;
        self.name = '';
        self.bank_no = '';
        self.description = '';
        self.sheba_no = '';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.bankAccTitle]), [this.$t("dialogs.ok")], 'delete_bank_confirm');

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBankAccount";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
